import React, { Fragment } from 'react';

import { Icon } from '@components/index'

import { ModalBgProps, openModalBg } from './ModalBg';

import styles from './index.module.less';

export interface ModalProps extends ModalBgProps {
  children: (params: Omit<ModalBgProps, 'children'>) => React.ReactNode;
}

const Modal: React.FC<ModalProps> = (props) => {
  const { children, ...rest } = props;
  console.log('line 12', rest)
  return (
    <Fragment>
      {children(rest)}
      <div className={styles.closeWrapper} data-buried='close'>
        <Icon name="modalClose" className={styles.iconClose} onClick={rest.removePreview} />
      </div>
    </Fragment>
  )
}

export interface IOpenModalIconCloseParams extends Omit<ModalProps, 'reject' | 'resolve' | 'removePreview'> {
  el: HTMLElement;
}

export const openModalIconClose = ({ el, children, className }: IOpenModalIconCloseParams) => {
  return openModalBg({
    el,
    className,
    children: (params) => <Modal {...params} >{children}</Modal>
  })
}
